import {Divider} from "@/components/divider/Divider.tsx";

import styles from "./ChartSummary.module.scss";

interface ChartSummaryProps {
  seriesCount: number;
  hiddenCount: number;
  /** Lines the last result drew, or null before there is one. */
  lineCount: number | null;
}

/**
 * Counts under the chart name. Lines are counted from the result, since one series split by
 * location or step draws many; that is what makes a chart crowded, not the series count.
 */
export const ChartSummary = ({seriesCount, hiddenCount, lineCount}: ChartSummaryProps) => (
  <div className={styles.summary}>
    <span>{seriesCount} series</span>
    {hiddenCount > 0 && (
      <>
        <Divider orientation="vertical" />
        <span>{hiddenCount} hidden</span>
      </>
    )}
    {lineCount !== null && (
      <>
        <Divider orientation="vertical" />
        <span>
          {lineCount} {lineCount === 1 ? "line" : "lines"} on chart
        </span>
      </>
    )}
  </div>
);
